module.exports = __webpack_public_path__ + "static/media/james_fun.8d77d488.png";